import * as React from 'react';
import { isMobileDevice } from '../utils';
import InputMask from 'react-input-mask';
import classNames from 'classnames';
import styles from './TimeInput.module.css';
import baseStyles from '../Base.module.css';
export default React.forwardRef(function TimeInput(props, ref) {
    var _a;
    var _b = props.isValid, isValid = _b === void 0 ? true : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, onChange = props.onChange, time = props.time;
    var update = function (event) {
        // ios safari clear button fix
        // https://github.com/facebook/react/issues/8938
        var nativeTarget = event.nativeEvent.target;
        setTimeout(function () {
            nativeTarget.defaultValue = '';
        }, 0);
        onChange(event.target.value);
    };
    var mask = [
        /[0-2]/,
        time[0] === '2' ? /[0-3]/ : /[0-9]/,
        ':',
        /[0-5]/,
        /[0-9]/
    ];
    var className = classNames(baseStyles.controlInput, styles.time, (_a = {},
        _a[baseStyles.controlInputInvalid] = !isValid,
        _a[baseStyles.controlInputDisabled] = disabled,
        _a[styles.container] = !isMobileDevice(),
        _a));
    return (React.createElement("div", { className: styles.outerContainer }, isMobileDevice() ? (React.createElement("input", { ref: ref, type: 'time', value: time, disabled: disabled, onChange: update, placeholder: '__:__', className: className })) : (React.createElement("div", { className: className, ref: ref },
        React.createElement(InputMask, { mask: mask, alwaysShowMask: true, value: time, onChange: update, disabled: disabled, "data-testid": props.name }),
        React.createElement("button", { type: 'button', className: baseStyles.deleteButton, onClick: function () { return onChange(''); } })))));
});
